function Authorization(authorizeAccount, status) {
  this.AuthorizeAccount = authorizeAccount;
  this.Status = status;
}

module.exports = Authorization;



//////////////////
// WEBPACK FOOTER
// ./models/authorization.js
// module id = 41
// module chunks = 0 5 20